module.exports = __webpack_public_path__ + "img/invoice-de-female-th.b49fbe74.png";